// Справочник по API: https://www.wix.com/velo/reference/api-overview/introduction

$w.onReady(function () {

    // Напишите свой код Javascript, используя API фреймворка Velo

    // Вывести Привет мир:
    // console.log(«Привет мир!»);

    // Вызовите функции на элементах страницы, напр.:
    // $w("#button1").label = «Кликнуть!»;

    // Кликнете «Запустить», или «Предпросмотр сайта», чтобы запустить код

});